<!-- s
  <div class="ttm-page-title-row-bg-layer ttm-bg-layer"></div>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="title-box d-flex align-items-center position-relative">
          <div class="page-title-heading text-white w-100 text-center">
            <h1 class="title text-white">Change Password</h1>
          </div>

          <div class="secondary-menu ms-auto text-black">
            <ul class="nav secondary-menu-list d-flex align-items-center" data-dropdown-in="fadeIn"
              data-dropdown-out="fadeOut">
              <li class="dropdown">
                <a class="relative rounded-bg" href="javascript:void(0)" id="navbarDropdownMenuLin"
                  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <img class="rounded-circle" src="assets/img/user-3.jpg" alt="User-image" width="55" height="55"
                    title="ClientName">
                  <div class="online-caret bg-primary circle"><i class="fa fa-caret-down"></i></div>
                </a>
                <div class="dropdown-menu rounded-0 dropdown-menu-right p-0" aria-labelledby="navbarDropdownMenuLin">
                  <a class="dropdown-item d-flex pb-2" routerLink="/session/home">
                    <div class="icon-area align-self-start">
                      <i class="fa fa-home text-white"></i>
                    </div>
                    <div class="icon-msg mx-2">
                      <span class="align-self-start d-block">{{'Home'}}</span>
                    </div>
                  </a>
                  <a class="dropdown-item d-flex pt-3" *ngIf="globals.UserName != ''">
                    <div class="icon-area align-self-start">
                      <i class="fa fa-user"></i>
                    </div>
                    <div class="icon-msg mx-2">
                      <span class="align-self-start d-block">{{globals.UserName}}</span>
                    </div>
                  </a>
                  <a class="dropdown-item d-flex pb-2" *ngIf="globals.UserName != ''"
                    routerLink="../tools/change-password">
                    <div class="icon-area align-self-start">
                      <i class="fa fa-cog"></i>
                    </div>
                    <div class="icon-msg mx-2">
                      <span class="align-self-start d-block">{{'Update Password'}}</span>
                    </div>
                  </a>
                  <a class="dropdown-item d-flex pb-2" *ngIf="globals.UserName != ''" (click)="LogOut()">
                    <div class="icon-area align-self-start">
                      <i class="fa fa-power-off"></i>
                    </div>
                    <div class="icon-msg mx-2">
                      <span class="align-self-start d-block">{{'Logout'}}</span>
                    </div>
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> -->

<div class="d-block d-sm-flex justify-content-center align-items-center mt-5">
  <div class="col-lg-4 mx-auto">
    <form #f="ngForm" novalidate>
      <div class="input-group mb-3">
        <input type="text" class="form-control" placeholder="Username" disabled [(value)]="itemToEdit.UserName">
      </div>
      <div class="input-group mb-3">
        <input type="text" class="form-control" placeholder="Old Password" [type]="hide ? 'password' : 'text'"
          id="Password" name="Password" maxlength="10" minlength="4" [(ngModel)]="itemToEditChangePassword.OldPassword">
        <div class="input-group-append">
          <span class="input-group-text">
            <i id='icons' class="fa" [ngClass]="hide ? ' fa-eye' : 'fa-eye-slash'" (click)="hide = !hide"></i></span>
        </div>
      </div>
      <div class="input-group mb-3">
        <input type="text" class="form-control" placeholder="New Password" [type]="hide1 ? 'password' : 'text'"
          id="Password1" name="Password1" maxlength="10" minlength="4"
          [(ngModel)]="itemToEditChangePassword.NewPassword" required>
        <div class="input-group-append">
          <span class="input-group-text">
            <i id='icons' class="fa " [ngClass]="hide1 ? 'fa-eye' : 'fa-eye-slash'" (click)="hide1 = !hide1"></i>
          </span>
        </div>
      </div>
      <div class="input-group mb-3">
        <input type="text" class="form-control" placeholder="Confirm Password" [type]="hide2 ? 'password' : 'text'"
          id="Password2" name="Password2" maxlength="10" minlength="4"
          [(ngModel)]="itemToEditChangePassword.ConfirmPassword" required>
        <div class="input-group-append">
          <span class="input-group-text">
            <i id='icons' class="fa " [ngClass]="hide2 ? 'fa-eye' : 'fa-eye-slash'" (click)="hide2 = !hide2"></i>
          </span>
        </div>
      </div>
      <div class="d-flex">
        <button type="button" class="btn btn-md bg-primary mr-3" (click)="Clear()">
          <i class="fa fa-eraser mr-1" aria-hidden="true"></i>
          Clear
        </button>
        <button type="button" id="saveChangePassword" class="btn btn-md bg-primary" (click)="saveChangePassword()"
          [disabled]="!f.valid || isInProgress">
          <i class="fa fa-save mr-1" aria-hidden="true"></i>
          Save
        </button>
      </div>
    </form>
  </div>
</div>